import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import { and, not } from 'ember-truth-helpers';
import { variation } from 'ember-launch-darkly';
import { LayoutSidebarSubnav } from 'core/components';

<template>
  {{#if @controller.shouldShowNav}}
    <LayoutSidebarSubnav as |Subnav|>
      {{#if (variation "hcp-ui-left-side-nav-new-structure")}}
        <Subnav.Link
          @iconPosition="leading"
          @icon="dashboard"
          @text={{t "nav.name-dashboard" name=(t "nav.organization.header")}}
          @route="cloud.orgs.detail.index"
        />
      {{else}}
        <Subnav.Link
          @iconPosition="leading"
          @icon="dashboard"
          @text={{@controller.model.organization.name}}
          @route="cloud.orgs.detail.index"
        />
        <Subnav.Title data-test-access-control-org-name>
          {{@controller.model.organization.name}}
        </Subnav.Title>
      {{/if}}
      {{! Show Projects link if user hasNoOrgRole and hasAccessibleProjects }}
      {{#if
        (and
          @controller.currentUser.hasNoOrgRole
          (not @controller.hasNoAccessibleProjects)
        )
      }}
        {{#let @controller.projectsLink as |link|}}
          <Subnav.Link
            @icon={{link.icon}}
            @models={{link.models}}
            @query={{link.query}}
            @route={{link.route}}
            @badge={{link.badge}}
            @text={{link.text}}
            data-test-main-nav-project-link={{link.id}}
          />
        {{/let}}
      {{/if}}
      {{#if @controller.currentUser.hasNoOrgRole}}
        <Subnav.Link
          @icon="users"
          @text={{t "nav.organization.settings.access-control"}}
          @route="cloud.access-control.groups"
          @query={{hash
            org_id=@controller.model.organization.id
            project_id=null
          }}
          data-test-access-control-subnav-link-groups
        />
      {{else}}
        {{#each @controller.model.menuLinks as |link|}}
          <Subnav.Link
            @icon={{link.icon}}
            @models={{link.models}}
            @query={{link.query}}
            @route={{link.route}}
            @badge={{link.badge}}
            @text={{link.text}}
            data-test-main-nav-project-link={{link.id}}
          />
        {{/each}}
        {{#if (variation "hcp-ui-left-side-nav-new-structure")}}
          <Subnav.Title data-test-main-nav-title-access-management>
            {{t "nav.headers.access-management"}}
          </Subnav.Title>
          {{#each @controller.model.accessControlLinks as |link|}}
            <Subnav.Link
              @icon={{link.icon}}
              @models={{link.models}}
              @query={{link.query}}
              @route={{link.route}}
              @badge={{link.badge}}
              @text={{link.text}}
              data-test-main-nav-project-link={{link.id}}
            />
          {{/each}}
          <Subnav.Title data-test-main-nav-title-admin>
            {{t "nav.headers.admin"}}
          </Subnav.Title>
          {{#each @controller.model.adminLinks as |link|}}
            <Subnav.Link
              @icon={{link.icon}}
              @models={{link.models}}
              @query={{link.query}}
              @route={{link.route}}
              @badge={{link.badge}}
              @text={{link.text}}
              data-test-main-nav-project-link={{link.id}}
            />
          {{/each}}
        {{/if}}
      {{/if}}

    </LayoutSidebarSubnav>
  {{/if}}

  {{outlet}}
</template>
